export const ACTIVATION_STATUS = Object.freeze({
  ACTIVE: 1,
  INACTIVE: 2
})
